
/* eslint-disable indent */
/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { unionBy, sortBy } from 'lodash';
import $ from 'jquery';
import { getAllRooms, getRooms } from '../../Store/Actions/RestActions';
import { connect } from 'react-redux';


class PageFilter extends Component {
	constructor(props) {
		super(props);

		this.state = {
		    filteredData: this.props.filterData,
			roomTypeFilter: [],
			resourceTypeFilter: [],
			buildingFilter: '',
			floorFilter: '',
			roomFilter: '',
			roleFilter: '',
			userGroupFilter: '',
			buildings: this.props.buildings,
			floors: this.props.floors || [],
			activePage: 1,
			rooms: this.props.rooms || [],
			isActiveFilter: "2" // 2 is Active&Inactive, 1 is Active, 0 is Inactive
		};

		this.handleSearch = this.handleSearch.bind(this);
		this.handleRoomTypeFilter = this.handleRoomTypeFilter.bind(this);
		this.handleResourceFilter = this.handleResourceFilter.bind(this);
		this.handleBuildingFilter = this.handleBuildingFilter.bind(this);
		this.handleFloorFilter = this.handleFloorFilter.bind(this);
		this.handleRoomFilter = this.handleRoomFilter.bind(this);
		this.runFilters = this.runFilters.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.handleRoleFilter = this.handleRoleFilter.bind(this);
		this.handleUserGroupFilter = this.handleUserGroupFilter.bind(this);
		this.filterUsersPage = this.filterUsersPage.bind(this);
		this.handleIsActiveFilter = this.handleIsActiveFilter.bind(this);
		this.handleShowInactiveRoomsFilter = this.handleShowInactiveRoomsFilter.bind(this);
		this.runFiltersAfterProps = this.runFiltersAfterProps.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.pageType === "users" && nextProps.length > 0) {
			this.setState({
				filteredData: nextProps.filterData.map(e => {
					let name = e.firstName + " " + e.lastName || "None";
					return { name, email: e.email, id: e.id, userName: e.userName, firstName: e.firstName, lastName: e.lastName, middleName: e.middleName, notes: e.notes }
				})
			});
		} else {
			if (this.state.filteredData.length > 0) {
				this.setState({
					filteredData: nextProps.filterData,
					buildings: nextProps.buildings,
					floors: nextProps.floors,
					rooms: nextProps.rooms,
				}, this.runFiltersAfterProps);
			} else {
				this.setState({
					filteredData: nextProps.filterData,
					buildings: nextProps.buildings,
					floors: nextProps.floors,
					rooms: nextProps.rooms,
				});
			}
		}

	}

	handleSearch(searchFilter, byId) {
		if (searchFilter === '' || searchFilter === null || !searchFilter) {
			if (this.props.pageType === "users") {
				this.setState({
					filteredData: this.props.filterData.map(e => {
						let name = e.firstName + " " + e.lastName || "None";
						return { name, isActive: e.isActive, email: e.email, id: e.id, userName: e.userName, firstName: e.firstName, lastName: e.lastName, middleName: e.middleName, notes: e.notes }
					})
				});
			} else {
				this.setState({ filteredData: this.props.filterData });
			}
			return this.props.filterData;
		}
		const inputValue = searchFilter.trim().toLowerCase();
		const inputLength = inputValue.length;
		// If users is the type
		if (this.props.pageType === "users") {
			this.setState({
				filteredData: this.props.filterData.filter(i => {
					if (i.firstName) {
						if (i.firstName.toLowerCase().slice(0, inputLength) === inputValue) return true;
					}

					if (i.lastName) {
						if (i.lastName.toLowerCase().slice(0, inputLength) === inputValue) return true;
					}

					if (i.email) {
						if (i.email.toLowerCase().slice(0, inputLength) === inputValue) return true;
					}
					return false;
				}).map(e => {
					let name = e.firstName + " " + e.lastName || "None";
					return { name, isActive: e.isActive, email: e.email, id: e.id, userName: e.userName, firstName: e.firstName, lastName: e.lastName, middleName: e.middleName, notes: e.notes }
				})
			});

		} else {
			if (byId) {
				this.setState({ filteredData: this.props.filterData.filter(i => i.id === byId) });
			} else {

				this.setState({
					filteredData: this.props.filterData.filter(i => {
						let nameMatch = i.name ? i.name.toLowerCase().slice(0, inputLength) === inputValue : false;
						let descriptionSplit = i.description ? i.description.toLowerCase().split(' ') : [];
						let descriptionMatch = i.description ? descriptionSplit.some(e => inputValue.split(' ').indexOf(e.slice(0, inputLength)) > -1) : false; // rather forgiving in searching each of the words and not requiring all to be present
						return nameMatch || descriptionMatch;
					})

				});

			}

			setTimeout(function () {
				$('.k-scheduler-table').css('width', '100%');
			}, 10);

		}
	}

	// added to handle active/inactive room toggle
	// 05-10-2019 JJ
	handleShowInactiveRoomsFilter(isChecked) {
		var checked = isChecked.target.checked;
		if(!checked){
			this.props.roomFetch();
		}
		else{
			this.props.roomFetchAll();
		}
	}

	handleRoomTypeFilter(roomTypeFilter) {
		this.runFilters(roomTypeFilter, this.state.resourceTypeFilter, this.state.buildingFilter, this.state.floorFilter, this.state.roomFilter);
		this.setState({ roomTypeFilter });
	}

	handleResourceFilter(resourceTypeFilter) {
		this.runFilters(this.state.roomTypeFilter, resourceTypeFilter, this.state.buildingFilter, this.state.floorFilter, this.state.roomFilter);
		this.setState({ resourceTypeFilter });
	}
	handleBuildingFilter(buildingFilter) {
		this.runFilters(this.state.roomTypeFilter, this.state.resourceTypeFilter, buildingFilter, this.state.floorFilter, this.state.roomFilter);
		this.setState({ buildingFilter });
	}
	handleFloorFilter(floorFilter) {
		this.runFilters(this.state.roomTypeFilter, this.state.resourceTypeFilter, this.state.buildingFilter, floorFilter, this.state.roomFilter);
		this.setState({ floorFilter});
		
	}
	handleRoomFilter(roomFilter) {
		this.runFilters(this.state.roomTypeFilter, this.state.resourceTypeFilter, this.state.buildingFilter, this.state.floorFilter, roomFilter);
		this.setState({ roomFilter});
	}

	// these three only apply on users page
	handleRoleFilter(roleFilter) {
		this.setState({ roleFilter }, this.filterUsersPage);
	}
	handleUserGroupFilter(userGroupFilter) {
		this.setState({ userGroupFilter }, this.filterUsersPage);
	}
	handleIsActiveFilter(isActiveFilter) {
		this.setState({ isActiveFilter }, this.filterUsersPage);
	}
	filterUsersPage() {
		let newFilterData = this.props.filterData;
		if (this.state.roleFilter.length !== 0) {

			//Clear out search query
			newFilterData = newFilterData.filter(e => e.roles.some(r => this.state.roleFilter.includes(r)))
		}

		if (this.state.userGroupFilter !== "") {

			newFilterData = newFilterData.filter(e => e.userGroupId === parseInt(this.state.userGroupFilter, 10));

		}

		if (parseInt(this.state.isActiveFilter, 10) === 1) {
			newFilterData = newFilterData.filter(e => e.isActive === true);
		}
		if (parseInt(this.state.isActiveFilter, 10) === 0) {
			newFilterData = newFilterData.filter(e => e.isActive === false);
		}

		this.setState({ filteredData: newFilterData });

	}

	////////////////////
	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
	}

	runFiltersAfterProps() {
		this.runFilters(this.state.roomTypeFilter, this.state.resourceTypeFilter, this.state.buildingFilter, this.state.floorFilter, this.state.roomFilter);
	}
	runFilters(roomTypeFilter, resourceTypeFilter, buildingFilter, floorFilter, roomFilter) {
		if (roomTypeFilter.length === 0 && resourceTypeFilter.length === 0 && buildingFilter === '' && floorFilter === '' && roomFilter === '') {
			this.setState({ filteredData: this.props.filterData, rooms: this.props.rooms, floors:this.props.floors });
			return true;
		}
		// we have filters, let's do it
		// filteredData is what is sent to the schedule to display
		// buildings floors and rooms are what's in the dropdowns
		let filteredData = this.props.filterData;
		let { buildings, floors, rooms } = this.props;
		if (roomTypeFilter.length > 0) {
			rooms = filteredData = filteredData.filter((room => roomTypeFilter.indexOf(room.roomTypeId) > -1));
		}
		// resource
		if (resourceTypeFilter.length > 0) {
			rooms = filteredData = filteredData.filter(((asset) => {
				return resourceTypeFilter.indexOf(asset.assetType.id) > -1;
			}));
		}

      

		// filtered based on select options above
		if (buildingFilter !== this.state.buildingFilter) {
			floorFilter = '';
			roomFilter = '';
		}
		if (buildingFilter !== '') {

			floors = floors.filter(floor => floor.buildingId === parseInt(buildingFilter, 10));
			floors = unionBy(floors, floors, 'id');
            rooms = filteredData = filteredData.filter(room => room.buildingId === parseInt(buildingFilter, 10));
		}


		if (floorFilter !== this.state.floorFilter) {
			roomFilter = '';
		}
		if (floorFilter !== '') {
			rooms = filteredData = filteredData.filter(room => room.floorId === parseInt(floorFilter, 10));
		}
		if (roomFilter !== '') {
			if (floorFilter !== '') {
				rooms = filteredData = filteredData.filter(room => room.floorId === parseInt(floorFilter, 10));
			}
			filteredData = filteredData.filter(room => room.id === parseInt(roomFilter, 10));
		}

		this.setState({ filteredData, rooms, floors, buildings, buildingFilter, floorFilter, roomFilter });

		// changing width of kendo scheduler based on number of rooms displayed
		if (window.location.pathname === "/schedule" || window.location.pathname === "/") {
			if (filteredData.length === 1) {
				setTimeout(function () {
					$(".k-scheduler-dayview .k-scheduler-content").css("width", "100%")
					$(".k-scheduler-dayview .k-scheduler-header").css("width", "100%")
					$(".k-scheduler-dayview .k-scheduler-table").css("width", "100%")
					$(".k-scheduler-dayview .k-scheduler-content .k-scheduler-table").css("width", "100%")
					$(".k-scheduler-dayview .k-scheduler-header .k-scheduler-table").css("width", "100%")
					// eslint-disable-next-line no-console
					}, 100);
			}
		}
	}
	render() {
		const childrenWithProps = React.Children.map(
			this.props.children,
			child => React.cloneElement(child, {
				...this.props,
				searchOnChange: this.handleSearch,
				floors: this.state.floors,
				rooms: this.state.rooms,
				filteredData: this.state.filteredData,
				activePage: this.state.activePage,
				handleRoomTypeFilter: this.handleRoomTypeFilter,
				handleResourceFilter: this.handleResourceFilter,
				handleBuildingFilter: this.handleBuildingFilter,
				handleFloorFilter: this.handleFloorFilter,
				handleRoomFilter: this.handleRoomFilter,
				handlePageChange: this.handlePageChange,
				handleRoleFilter: this.handleRoleFilter,
				handleUserGroupFilter: this.handleUserGroupFilter,
				handleIsActiveFilter: this.handleIsActiveFilter,
				buildingFilter: this.state.buildingFilter,
				floorFilter: this.state.floorFilter,
				roomFilter: this.state.roomFilter,
				handleShowInactiveRoomsFilter: this.handleShowInactiveRoomsFilter
			})
		);
		return (
			<div>{childrenWithProps}</div>
		);
	}
}

PageFilter.propTypes = {
	buildings: PropTypes.arrayOf(PropTypes.object),
	floors: PropTypes.arrayOf(PropTypes.object),
};



// added to handle active/inactive room toggle
// 05-10-2019 JJ
const mapStateToProps = state => ({
	rooms: state.rooms.data,
});

// added to handle active/inactive room toggle
// 05-10-2019 JJ
const mapDispatchtoProps = dispatch => ({
	roomFetchAll: () => dispatch(getAllRooms()),
			
});


//export default PageFilter;
// updated to handle active/inactive room toggle
// 05-10-2019 JJ
export default connect(mapStateToProps, mapDispatchtoProps)(PageFilter );


// WEBPACK FOOTER //
// ./src/Components/Pages/PageFilter.js